import React, { useEffect, useLayoutEffect, useRef } from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { motion } from 'framer-motion';
import { springVariants, springViewport } from '../utils/framerVariants';


const HorizontalGalery = ({ data }) => {

  const isVideo = data.Media && data.Media.mime && data.Media.mime.startsWith("video");
  const componentId = data.id;

  const useIsomorphicLayoutEffect = typeof window !== "undefined"
  ? useLayoutEffect
  : useEffect;

  useIsomorphicLayoutEffect(() => {

      gsap.registerPlugin(ScrollTrigger);

      const myHorizontal = `.panel__${componentId}`

      const sections = gsap.utils.toArray(myHorizontal);
        let maxWidth = 0;

        const getMaxWidth = () => {
          maxWidth = 0;
          sections.forEach((section) => {
            maxWidth += section.offsetWidth;
          });
        };

        getMaxWidth();
        ScrollTrigger.addEventListener("refreshInit", getMaxWidth);

        gsap.to(sections, {
          x: () => `-${maxWidth - window.innerWidth}`,
          ease: "none",
          scrollTrigger: {
            trigger: `#trigger__${data.id}`,
            pin: true,
            scrub: true,
            start: "50% 50%",
            end: () => `+=${maxWidth}`
          }
        });

        ScrollTrigger.refresh(true);

  }, [componentId]);

  return (
    <article className="mb-16 md:mb-24 lg:mb-32 xl:mb-48 relative">
      <div className="overflow-hidden relative" >
        <div className="flex flex-nowrap w-screen items-start justify-start" id={`trigger__${componentId}`}>
          <div className="absolute top-[40%] md:top-[50%] lg:top-[40%] left-[-2.5%] z-[0] rotate-[10deg] w-[105%] border-b-4 border-black"></div>
          {data.HorizontalEntries.map((entry, i) => (
            <div className={`flex-shrink-0 w-full md:w-9/12 lg:w-7/12 pl-4 md:pl-16 lg:pl-24 pr-24 md:pr-16 lg:pr-24 panel__${componentId}`}>
              <div className="grid grid-cols-1 bg-white">
                <div className="mb-2 w-full overflow-hidden">
                  {isVideo ? (
                    <>
                      {entry.Media &&
                        <video className="h-full w-full object-cover" playsInline autoPlay loop mute="true" muted>
                          <source src={entry.Media.file.url} type={entry.Media.mime} />
                        </video>
                      }
                    </>
                  ) : (
                    <>
                      {entry.Media && <GatsbyImage
                      image={getImage(entry.Media.file)}
                      alt={entry.Media.alternativeText || "Alternative Text missing"}
                      />
                    }
                   </>
                  )}
                </div>
                <div className="pr-4">
                  {entry.Title && <p className="mb-0"><b>{entry.Title}</b></p>}
                  {entry.Text && <div dangerouslySetInnerHTML={{ __html: entry.Text }} />}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </article>
  );
};

export default HorizontalGalery;
